import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CodigoEppoService } from './codigoeppo.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { TwTcEppoViewModel } from 'src/app/components/core/_infrastructure/types/common';

@Component({
    selector: 'app-codigoeppo-edit',
    templateUrl: './codigoeppo-edit.component.html',
})
export class CodigoEppoEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nuevo';
    codigoEppo: TwTcEppoViewModel;
    visibilitySpinner: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private codigoEppoService: CodigoEppoService,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.codigoEppo = new TwTcEppoViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.codigoEppoService.getCodigoEppo(id).subscribe(result => {
                this.codigoEppo = result;
                this.updateForm();
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            CodigoEppo: ['', Validators.required],
            InvasivaNoPermitida: [false, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            CodigoEppo: this.codigoEppo.CodigoEppo,
            InvasivaNoPermitida: this.codigoEppo.InvasivaNoPermitida,
        });
    }

    onCleanButton() {
        this.form.setValue({
            CodigoEppo: '',
            InvasivaNoPermitida: false,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let codigoEppo = new TwTcEppoViewModel();

        codigoEppo.CodigoEppo = this.form.value.CodigoEppo;
        codigoEppo.InvasivaNoPermitida = this.form.value.InvasivaNoPermitida;

        codigoEppo.Id = this.codigoEppo.Id;

        if (this.editMode) {
            this.codigoEppoService.editCodigoEppo(codigoEppo).subscribe({
                next: res => {
                    this.addSuccessMessage('Código Eppo modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.codigoEppoService.createCodigoEppo(codigoEppo).subscribe({
                next: res => {
                    this.addSuccessMessage('Código Eppo añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/especies/codigoseppo']);
    }
}
